import { render, staticRenderFns } from "./Homeworkanswer.vue?vue&type=template&id=f8dc31ee"
import script from "./Homeworkanswer.vue?vue&type=script&lang=js"
export * from "./Homeworkanswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports